import { ReduxActionType, ApiResponseInfo, AddressType } from 'types';

export interface NewLodgeEnquiry {
  name: string;
  role: string;
  primaryContactId?: number;
  utilityId?: number;
}

interface ActionType {
  FETCH_LODGE_ENQUIRY_INIT: any;
  FETCH_LODGE_ENQUIRY_REQUEST: any;
  FETCH_LODGE_ENQUIRY_SUCCESS: ReduxActionType;
  FETCH_LODGE_ENQUIRY_FAILURE: ReduxActionType;
  SET_ENQUIRY_ADDRESS: ReduxActionType;
  SET_SHAPE: ReduxActionType;
  CLEAR_SHAPE: ReduxActionType;
  FETCH_LAST_ENQUIRY_REQUEST: ReduxActionType;
  FETCH_LAST_ENQUIRY_SUCCESS: ReduxActionType;
  FETCH_LAST_ENQUIRY_FAILURE: ReduxActionType;
  CLEAR_LAST_ENQUIRY: ReduxActionType;
  FETCH_ENQUIRY_JOB_REQUEST: ReduxActionType;
  FETCH_ENQUIRY_JOB_SUCCESS: ReduxActionType;
  CLONE_EXISTING_ENQUIRY_REQUEST: ReduxActionType;
  CLONE_EXISTING_ENQUIRY_FAILURE: ReduxActionType;
  CLEAR_CLONE_ENQUIRY: ReduxActionType;
  CLEAR_LODGE_ENQUIRY_DETAILS: ReduxActionType;
  SANDBOX_TESTING_MODE: string;
  SAVE_ENQUIRY_PRESETS_START: string;
  SAVE_ENQUIRY_PRESETS_SUCCESS: string;
  SAVE_ENQUIRY_PRESETS_FAILURE: string;
  DELETE_ENQUIRY_PRESETS_START: string;
  DELETE_ENQUIRY_PRESETS_SUCCESS: string;
  DELETE_ENQUIRY_PRESETS_FAILURE: string;
  GO_TO_ENQUIRY_PRESETS: string;
  RETURN_FROM_ENQUIRY_PRESETS: string;
  COMPLETED_RETURN_FROM_ENQUIRY_PRESETS: string;
  CLEAR_ENQUIRY_PRESETS: string;
  UPDATE_LODGE_ENQUIRY_REFERRAL: string;
  PRE_POPULATE_ENQUIRY_DATA: string;
  SET_LIVE_AREA: string;
}

export const LodgeEnquiryActionTypes: ActionType = {
  FETCH_LODGE_ENQUIRY_INIT: '@@FETCH_LODGE_ENQUIRY_INIT',
  FETCH_LODGE_ENQUIRY_REQUEST: '@@FETCH_LODGE_ENQUIRY_REQUEST',
  FETCH_LODGE_ENQUIRY_SUCCESS: '@@FETCH_LODGE_ENQUIRY_SUCCESS',
  FETCH_LODGE_ENQUIRY_FAILURE: '@@FETCH_LODGE_ENQUIRY_FAILURE',
  SET_ENQUIRY_ADDRESS: '@@SET_ENQUIRY_ADDRESS',
  SET_SHAPE: '@@SET_SHAPE',
  CLEAR_SHAPE: '@@CLEAR_SHAPE',
  FETCH_LAST_ENQUIRY_REQUEST: '@@FETCH_LAST_ENQUIRY_REQUEST',
  FETCH_LAST_ENQUIRY_SUCCESS: '@@FETCH_LAST_ENQUIRY_SUCCESS',
  FETCH_LAST_ENQUIRY_FAILURE: '@@FETCH_LAST_ENQUIRY_FAILURE',
  CLEAR_LAST_ENQUIRY: '@@CLEAR_LAST_ENQUIRY',
  FETCH_ENQUIRY_JOB_REQUEST: '@@FETCH_ENQUIRY_JOB_REQUEST',
  FETCH_ENQUIRY_JOB_SUCCESS: '@@FETCH_ENQUIRY_JOB_SUCCESS',
  CLONE_EXISTING_ENQUIRY_REQUEST: '@@CLONE_EXISTING_ENQUIRY_REQUEST',
  CLONE_EXISTING_ENQUIRY_FAILURE: '@@CLONE_EXISTING_ENQUIRY_FAILURE',
  CLEAR_CLONE_ENQUIRY: '@@CLEAR_CLONE_ENQUIRY',
  CLEAR_LODGE_ENQUIRY_DETAILS: '@@CLEAR_LODGE_ENQUIRY_DETAILS',
  SANDBOX_TESTING_MODE: '@@SANDBOX_TESTING_MODE',
  SAVE_ENQUIRY_PRESETS_START: '@@SAVE_ENQUIRY_PRESETS_START',
  SAVE_ENQUIRY_PRESETS_SUCCESS: '@@SAVE_ENQUIRY_PRESETS_SUCCESS',
  SAVE_ENQUIRY_PRESETS_FAILURE: '@@SAVE_ENQUIRY_PRESETS_FAILURE',
  DELETE_ENQUIRY_PRESETS_START: '@@DELETE_ENQUIRY_PRESETS_START',
  DELETE_ENQUIRY_PRESETS_SUCCESS: '@@DELETE_ENQUIRY_PRESETS_SUCCESS',
  DELETE_ENQUIRY_PRESETS_FAILURE: '@@DELETE_ENQUIRY_PRESETS_FAILURE',
  GO_TO_ENQUIRY_PRESETS: '@@GO_TO_ENQUIRY_PRESETS',
  RETURN_FROM_ENQUIRY_PRESETS: '@@RETURN_FROM_ENQUIRY_PRESETS',
  COMPLETED_RETURN_FROM_ENQUIRY_PRESETS:
    '@@COMPLETED_RETURN_FROM_ENQUIRY_PRESETS',
  CLEAR_ENQUIRY_PRESETS: '@@CLEAR_ENQUIRY_PRESETS',
  UPDATE_LODGE_ENQUIRY_REFERRAL: '@@UPDATE_LODGE_ENQUIRY_REFERRAL',
  PRE_POPULATE_ENQUIRY_DATA: '@@PRE_POPULATE_ENQUIRY_DATA',
  SET_LIVE_AREA: '@@SET_LIVE_AREA'
};

export interface LodgeEnquiryState {
  submitting: boolean;
  errors?: string;
  job?: Object;
  enquiry: any;
  address?: AddressType;
  shape?: GeoJSON.GeometryObject;
  data?: string;
  shapeArea?: number;
  lastEnquiry?: Object;
  channelTestMode?: any;
  presets?: EnquiryPresets;
  liveArea?: number;
  prePopulatedData?: any;
}
export interface LodgeEnquiryPayloadType {
  userReference: string;
  digStartAt: string;
  digEndAt: string;
  shape: GeoJSON.GeometryObject;
  Address: AddressType;
  isPlanningJob: boolean | null;
  activityTypes: string;
  authorityId: string | number | null;
  notes: string;
  locationTypes: string[];
  locationsInRoad: string[];
}

export interface EnquiryPresets {
  status?:
    | 'saving'
    | 'returning'
    | 'returned'
    | 'initial'
    | 'error'
    | 'saved'
    | 'deleting'
    | 'deleted';
  shape?: GeoJSON.GeometryObject;
  shapeArea?: number;
  address?: AddressType;
  formData?: any;
  error?: string;
}

export interface Enquiry {
  id?: number;
  digStartAt: string;
  digEndAt: string;
  CustomFields: LodgeEnquiryPayloadType;
}

export interface EnquiryItem extends LodgeEnquiryPayloadType {
  id: number;
  digStartAt: string;
  digEndAt: string;
}

export interface EnquiryShape {
  type: string;
  coordinates: number[][][];
}

export interface loadEnqueriesSuccessPayload {
  items: EnquiryItem[];
}

export interface loadEnqueriesFailurePayload {
  error: ApiResponseInfo;
}

export interface MapLocationFormDataType {
  addressLine1: string;
  locality: string;
  state: string;
  postcode: string;
  locationTypes: string[];
  locationsInRoad: string[];
  rrLocationType: boolean;
  prLocationType: boolean;
}
export interface JobDateSelectionFormDataType {
  digStartAt: string;
  digEndAt: string;
  autoRenewUntil?: string;
  enquiryType: string;
  autoRenewToggle?: boolean;
  activityTypes: string;
  isPlanningJob: boolean | null;
}

export interface SelectAssetsOwnersFormDataType {
  userReference: string;
  notes: string;
  authorityId: string | number | null;
  otherAuthorityName?: string;
}

export interface UpdateUserProfileFormDataType {
  phoneNumber: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  locality: string;
  state: string;
  postcode: string;
}

export interface Address {
  line1: string;
  line2?: string;
  locality: string;
  postcode: string;
  state: string;
  country?: string;
}
export interface LodgeNewEnqiryTypes {
  autoRenewUntil?: string;
  enquiryType?: string;
  otherAuthorityName?: string;
  userReference: string;
  digStartAt: string;
  digEndAt: string;
  shape?: GeoJSON.GeometryObject;
  Address?: AddressType;
  phoneNumber?: string | null;
  isPlanningJob: boolean | null;
  activityTypes: string;
  authorityId: string | number | null;
  notes: string;
  locationTypes: string[];
  locationsInRoad: string[];
  webLaunchRequestId?: string;
}

export interface LodgeEnqiryStep1DataType {
  userReference: string;
  digStartAt: string;
  digEndAt: string;
  notes: string;
  addressLine1: string;
  autoRenewUntil?: string;
}

export interface LodgeEnqiryStep2DataType {
  isPlanningJob: boolean | null;
  enquiryType: string;
  locationTypes: string[];
  authorityId: string | number | null;
  locationsInRoad: string[];
  activityTypes: string;
  otherAuthorityName?: string;
}

export enum JOB_STATUS_CODE {
  CREATED = 'CREATED',
  WAITING = 'WAITING',
  COMPLETED = 'COMPLETED',
  TIMEDOUT = 'TIMEDOUT',
  FAILED = 'FAILED'
}

export enum ENQUIRY_STATUS_CODE {
  ALL_RECEIVED = 'ALL_RECEIVED',
  WAITING = 'WAITING',
  EXPIRED = 'EXPIRED'
}

export enum LOCATION_TYPES_CODE {
  ROAD = 'Road Reserve',
  PRIVATE = 'Private'
}
